import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";

interface NewsPreviewProps {
  featured: NewsItem;
  items: NewsItem[];
}

export default function NewsPreview({ featured, items }: NewsPreviewProps) {
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-[1.05fr_1fr]">
      <Link
        to={`/news/${featured.id}`}
        className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50"
      >
        <div className="h-44 w-full overflow-hidden bg-background-200 md:h-48">
          <img
            src={featured.cover}
            alt={`${featured.title} 资讯配图`}
            title={`${featured.title} - 三级片影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </div>
        <div className="p-4 md:p-5">
          <div className="flex flex-wrap items-center gap-2 text-[11px]">
            <span className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-800">
              {featured.category}
            </span>
            <span className="text-foreground-400">{featured.date}</span>
          </div>
          <h3 className="mt-2 line-clamp-2 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
            {featured.title}
          </h3>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {featured.summary}
          </p>
        </div>
      </Link>

      <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex cursor-pointer flex-col justify-center px-4 py-3.5 transition-colors hover:bg-background-100"
          >
            <div className="flex items-center gap-2 text-[11px] text-foreground-400">
              <span className="h-1 w-1 rounded-full bg-secondary-500" />
              {item.category}
              <span className="text-background-400">·</span>
              {item.date}
            </div>
            <h4 className="mt-1.5 line-clamp-2 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700">
              {item.title}
            </h4>
          </Link>
        ))}
      </div>
    </div>
  );
}